import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4def6455")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BorderLine = _resolveComponent("BorderLine")
  const _component_ResizeHandler = _resolveComponent("ResizeHandler")

  return (_openBlock(), _createBlock("div", {
    class: "multi-select-operate",
    style: {
      left: _ctx.minX * _ctx.canvasScale + 'px',
      top: _ctx.minY * _ctx.canvasScale + 'px',
    }
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.borderLines, (line) => {
      return (_openBlock(), _createBlock(_component_BorderLine, {
        key: line.type,
        type: line.type,
        style: line.style
      }, null, 8, ["type", "style"]))
    }), 128)),
    (!_ctx.disableResize)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.resizeHandlers, (point) => {
          return (_openBlock(), _createBlock(_component_ResizeHandler, {
            key: point.direction,
            type: point.direction,
            style: point.style,
            onMousedown: _withModifiers(($event: any) => (_ctx.scaleMultiElement($event, { minX: _ctx.minX, maxX: _ctx.maxX, minY: _ctx.minY, maxY: _ctx.maxY }, point.direction)), ["stop"])
          }, null, 8, ["type", "style", "onMousedown"]))
        }), 128))
      : _createCommentVNode("", true)
  ], 4))
})